import { useContext } from "react";

import GlobalContext from "../../isp._comun/contexto/GlobalContext";
import * as TipoDeError from "../../isp._comun/servicios/Errores";
import useHandlerDeServicio from "../../isp._comun/componentes/useHandlerDeComando";

const useHandlerDeComandoConSesionActiva = (funcionQueLanzaElServicio) => {
    const { cargarPantallaLogin } = useContext(GlobalContext);

    return useHandlerDeServicio(async (input) => {
        try {
            await funcionQueLanzaElServicio(input);
        } catch (error) {
            if (error instanceof TipoDeError.ErrorEnIdSesion) {
                cargarPantallaLogin();
                return;
            }
            throw error;
        }
    });
};

export default useHandlerDeComandoConSesionActiva;
